import { motion } from "framer-motion";
import { EASE } from "./Reveal";

export default function PageTransition({ children }) {
  return (
    <motion.div initial={{ opacity: 1 }} animate={{ opacity: 1 }} exit={{ opacity: 1 }}>
      <motion.div
        data-testid="page-curtain"
        className="fixed inset-0 z-[120] bg-espresso pointer-events-none"
        initial={{ scaleY: 1, transformOrigin: "50% 0%" }}
        animate={{ scaleY: 0 }}
        exit={{ scaleY: 1, transformOrigin: "50% 100%" }}
        transition={{ duration: 0.65, ease: EASE }}
      />
      {children}
    </motion.div>
  );
}
